import React, { useEffect, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import './style.scss';
import StepInfo from './StepsInfo';
import ZohoMapLocations from './Steps/zohoMapLocations';
import ZohoPullData from './Steps/zohoPullData';
import ZohoSuccess from './Steps/zohoSuccess';
import ZohoIntegrationActions from '@Actions/integrations/zohoIntegrationActions';

/**
 *
 */
const ZohoSetup = ({ getZohoConnectionsLoading, getTenantsLoading, user, getZohoConnections }) => {
  const [step, setStep] = useState(1);
  const [zohoConnections, setZohoConnections] = useState([]);

  useEffect(() => {
    getZohoConnections(user?.tenant_info?.org_id, (data) => {
      setZohoConnections(data);
    });
  }, []);

  return (
    <Fragment>
      <div className="zoho-integration-wrapper">
        <div className="zoho-integration__heading">Zoho Books Integration </div>
        <div className="ant-row">
          <div className="ant-col-md-5">
            <StepInfo step={step} loading={getZohoConnectionsLoading || getTenantsLoading} />
          </div>
          <div className="ant-col-md-19">
            {step === 1 && (<ZohoMapLocations setStep={setStep} />)}
            {step === 2 && (<ZohoPullData setStep={setStep} preFillData={zohoConnections?.find((item) => item?.is_active)} />)}
            {step === 3 && (<ZohoSuccess setStep={setStep} />)}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,

});

const mapDispatchToProps = (dispatch) => ({
  getZohoConnections: (orgId, callback) => dispatch(ZohoIntegrationActions.getZohoConnections(orgId, callback)),

});

ZohoSetup.propTypes = {
  getZohoConnectionsLoading: PropTypes.bool,
  getTenantsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ZohoSetup));
